/* AagamStuti bag extras. Loads after aagamstuti.js and takes over the bag buttons, so the order note and focus survive a refresh, stock errors are told, and phones get an add-to-bag stepper on cards. */
(function () {
  'use strict';
  var AS = window.AS || {}, routes = AS.routes || {}, doc = document;
  function $(s, c) { return (c || doc).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || doc).querySelectorAll(s)); }
  function text(el) { return el ? el.textContent.replace(/\s+/g, ' ').trim() : ''; }
  var touch = !!(window.matchMedia && matchMedia('(hover: none)').matches);
  var cartUrl = routes.cart || '/cart';

  /* ---------- polite announcer ---------- */
  var live = doc.createElement('div');
  live.className = 'as-vh'; live.setAttribute('role', 'status'); live.setAttribute('aria-live', 'polite');
  doc.body.appendChild(live);
  function say(t) { live.textContent = ''; setTimeout(function () { live.textContent = t; }, 60); }

  function post(url, data) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(data) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }, function () { return { ok: r.ok, data: {} }; }); });
  }
  function why(res, fallback) { var d = res && res.data; return (d && (d.description || d.message)) || fallback; }
  function getCart() { return fetch(routes.cartJs || '/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }

  /* ---------- bag state, cards and counts ---------- */
  var held = {};
  function setCount(n) {
    $$('[data-cart-count],[data-cart-count-inline]').forEach(function (el) { el.textContent = n; el.hidden = n === 0; });
    $$('.as-hdr__bag').forEach(function (a) { a.setAttribute('aria-label', 'Bag, ' + n + ' items'); });
  }
  function applyCart(c) {
    held = {};
    c.items.forEach(function (i) { var h = held[i.variant_id]; if (h) h.qty += i.quantity; else held[i.variant_id] = { qty: i.quantity, key: i.key }; });
    setCount(c.item_count);
    syncCards();
    return c;
  }
  function ensureStep(plate) {
    var s = $('.as-plate__step', plate), q = $('[data-quick-add]', plate);
    if (s || !q) return s;
    var name = text($('.as-plate__name', plate));
    s = doc.createElement('div'); s.className = 'as-plate__step'; s.setAttribute('role', 'group'); s.setAttribute('aria-label', name + ' in your bag');
    [['dec', '−', 'Remove one ' + name], ['n'], ['inc', '+', 'Add one more ' + name]].forEach(function (d) {
      var el = doc.createElement(d[0] === 'n' ? 'span' : 'button');
      if (d[0] === 'n') { el.className = 'as-plate__n'; el.setAttribute('aria-hidden', 'true'); }
      else { el.type = 'button'; el.setAttribute('data-step', d[0]); el.textContent = d[1]; el.setAttribute('aria-label', d[2]); }
      s.appendChild(el);
    });
    q.parentNode.insertBefore(s, q.nextSibling);
    return s;
  }
  function syncCards() {
    if (!touch) return;
    $$('.as-plate').forEach(function (p) {
      var q = $('[data-quick-add]', p);
      if (!q) return;
      var h = held[q.getAttribute('data-quick-add')], s = ensureStep(p);
      p.classList.toggle('has-qty', !!h);
      if (h) $('.as-plate__n', s).textContent = h.qty;
    });
  }

  /* ---------- refresh the drawer and the bag page ---------- */
  function swap(host, fresh) { if (host && fresh) host.innerHTML = fresh.innerHTML; }
  function parse(html, sel) { var t = doc.createElement('div'); t.innerHTML = html; return $(sel, t); }
  function refresh() { return (AS.flush ? AS.flush() : Promise.resolve()).then(redraw); }
  function redraw() {
    var jobs = [getCart().then(applyCart)];
    var drawer = $('#cart-drawer');
    if (drawer) {
      jobs.push(fetch((routes.root || '/') + '?sections=cart-drawer').then(function (r) { return r.json(); }).then(function (d) {
        var fresh = parse(d['cart-drawer'] || '', '#cart-drawer');
        if (!fresh) return;
        swap($('[data-cart-drawer-body]', drawer), $('[data-cart-drawer-body]', fresh));
        var f = $('[data-cart-drawer-foot]', drawer), nf = $('[data-cart-drawer-foot]', fresh);
        if (f && nf) f.innerHTML = nf.innerHTML; else if (f) f.remove(); else if (nf) $('.as-drawer2', drawer).appendChild(nf);
      }));
    }
    var page = $('[data-cart-section]');
    if (page) {
      var note = $('#cart-note'), typed = note ? note.value : null, had = note && doc.activeElement === note;
      jobs.push(fetch(cartUrl + '?section_id=' + page.getAttribute('data-section-id')).then(function (r) { return r.text(); }).then(function (html) {
        swap(page, parse(html, '[data-cart-section]'));
        var n2 = $('#cart-note');
        if (n2 && typed !== null) { n2.value = typed; if (had) n2.focus(); }
      }));
    }
    return Promise.all(jobs);
  }
  function afterAdd() {
    if (AS.cartType === 'page') { location.href = cartUrl; return; }
    var opener = $('[data-cart-open]');
    if (opener && $('#cart-drawer') && !/\/cart(\?|$)/.test(location.pathname)) opener.click();
    else refresh();
  }

  /* ---------- clicks (capture, so the older handlers stand down) ---------- */
  function take(e) { e.preventDefault(); e.stopImmediatePropagation(); }
  doc.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : e.target.parentElement;
    if (!t) return;

    var lq = t.closest('[data-line-qty]');
    if (lq && lq.closest('[data-line]')) { take(e); changeLine(lq); return; }

    var q = t.closest('[data-quick-add]');
    if (q) { take(e); quickAdd(q); return; }

    var set = t.closest('[data-add-set]');
    if (set) { take(e); addSet(set); return; }

    var st = t.closest('[data-step]');
    if (st) { take(e); step(st); }
  }, true);

  function changeLine(btn) {
    var line = btn.closest('[data-line]'), key = line.getAttribute('data-line'), qty = Number(btn.getAttribute('data-line-qty'));
    var hostSel = btn.closest('#cart-drawer') ? '#cart-drawer' : '[data-cart-section]', act = btn.getAttribute('data-act') || '';
    var name = text($('h3', line)), idx = $$('[data-line]', $(hostSel)).indexOf(line);
    if (line.classList.contains('is-busy')) return;
    line.classList.add('is-busy'); line.setAttribute('aria-busy', 'true');
    function undo(msg) {
      line.classList.remove('is-busy'); line.removeAttribute('aria-busy');
      var p = $('.as-cline__err', line) || line.querySelector('div').appendChild(doc.createElement('p'));
      p.className = 'as-cline__err'; p.setAttribute('role', 'alert'); p.textContent = msg;
      setTimeout(function () { if (p.parentNode) p.remove(); }, 6000);
    }
    post((routes.cartChange || '/cart/change') + '.js', { id: key, quantity: qty }).then(function (res) {
      if (!res.ok) { undo(why(res, 'That quantity is not available.')); return; }
      return refresh().then(function () {
        var host = $(hostSel), again = host && $$('[data-line]', host).filter(function (l) { return l.getAttribute('data-line') === key; })[0], go = null;
        if (again) go = $('[data-act="' + act + '"]', again) || $('button,a', again);
        else {
          var rest = host ? $$('[data-line]', host) : [];
          go = rest.length ? $('[data-act="remove"]', rest[Math.min(idx, rest.length - 1)]) : (hostSel === '#cart-drawer' ? $('button[data-cart-close]', host) : $('h1', host));
          if (go && !/^(A|BUTTON)$/.test(go.tagName)) go.setAttribute('tabindex', '-1');
        }
        if (go) go.focus();
        say(qty === 0 ? name + ' removed from your bag.' : name + ', quantity ' + qty + '.');
      });
    }).catch(function () { undo('Something went wrong. Please try again.'); });
  }

  function quickAdd(q) {
    var label = $('span', q), old = label ? label.textContent : '', plate = q.closest('.as-plate'), name = text(plate && $('.as-plate__name', plate)) || 'Item';
    function flash(t) { if (label) { label.textContent = t; setTimeout(function () { label.textContent = old; }, 1800); } }
    q.disabled = true;
    post((routes.cartAdd || '/cart/add') + '.js', { items: [{ id: Number(q.getAttribute('data-quick-add')), quantity: 1 }] }).then(function (res) {
      q.disabled = false;
      if (!res.ok) { flash('Unavailable'); say(name + ': ' + why(res, 'could not be added.')); return; }
      flash('Added');
      if (touch && plate) getCart().then(applyCart).then(function () { say(name + ' added to your bag.'); });
      else afterAdd();
    }).catch(function () { q.disabled = false; flash('Try again'); });
  }

  function step(btn) {
    var plate = btn.closest('.as-plate'), q = $('[data-quick-add]', plate), id = q.getAttribute('data-quick-add'), h = held[id], name = text($('.as-plate__name', plate));
    var up = btn.getAttribute('data-step') === 'inc', both = $$('[data-step]', plate);
    both.forEach(function (b) { b.disabled = true; });
    var job = up
      ? post((routes.cartAdd || '/cart/add') + '.js', { items: [{ id: Number(id), quantity: 1 }] })
      : post((routes.cartChange || '/cart/change') + '.js', { id: h ? h.key : id, quantity: Math.max(0, (h ? h.qty : 1) - 1) });
    job.then(function (res) {
      if (!res.ok) { say(name + ': ' + why(res, 'that quantity is not available.')); return; }
      return getCart().then(applyCart).then(function () {
        var n = held[id] ? held[id].qty : 0;
        say(n ? name + ', ' + n + ' in your bag.' : name + ' removed from your bag.');
      });
    }).then(function () {
      both.forEach(function (b) { b.disabled = false; });
      if (!held[id]) { var qq = $('[data-quick-add]', plate); if (qq) qq.focus(); }
    }, function () { both.forEach(function (b) { b.disabled = false; }); });
  }

  /* a set is added in one go; when one piece is short of stock the others still go in */
  function addSet(btn) {
    var ids = btn.getAttribute('data-add-set').split(',').filter(Boolean).map(Number);
    var msg = btn.parentNode.querySelector('[data-set-msg]');
    if (!msg) { msg = doc.createElement('p'); msg.className = 'as-setmsg'; msg.setAttribute('data-set-msg', ''); msg.setAttribute('role', 'status'); btn.insertAdjacentElement('afterend', msg); }
    msg.textContent = '';
    if (!ids.length) { msg.textContent = 'Tick at least one piece to add.'; return; }
    btn.disabled = true;
    var add = function (list) { return post((routes.cartAdd || '/cart/add') + '.js', { items: list.map(function (id) { return { id: id, quantity: 1 }; }) }); };
    add(ids).then(function (res) {
      if (res.ok) return { done: ids.length, skipped: 0 };
      var done = 0, skipped = 0;
      return ids.reduce(function (p, id) { return p.then(function () { return add([id]).then(function (r) { if (r.ok) done++; else skipped++; }); }); }, Promise.resolve()).then(function () { return { done: done, skipped: skipped }; });
    }).then(function (r) {
      btn.disabled = false;
      if (r.skipped) { msg.textContent = r.done ? r.skipped + ' piece' + (r.skipped > 1 ? 's were' : ' was') + ' out of stock; the rest are in your bag.' : 'These pieces are out of stock right now.'; say(msg.textContent); }
      if (r.done) afterAdd();
    }).catch(function () { btn.disabled = false; msg.textContent = 'Something went wrong. Please try again.'; });
  }

  /* ---------- filters: keep focus, announce the count, follow Back ---------- */
  doc.addEventListener('change', function (e) {
    var t = e.target, form = t.closest && t.closest('[data-filters-form]');
    if (!form) return;
    var name = t.name, value = t.value;
    var mo = new MutationObserver(function () {
      mo.disconnect();
      var again = $$('input,select', form).filter(function (x) { return x.name === name && x.value === value; })[0];
      if (again) again.focus({ preventScroll: true });
      say(text($('[data-result-count]')) || 'Results updated.');
    });
    mo.observe(form, { childList: true });
    setTimeout(function () { mo.disconnect(); }, 5000);
  }, true);
  var seen = location.pathname + location.search, push = history.pushState;
  history.pushState = function () { var r = push.apply(this, arguments); seen = location.pathname + location.search; return r; };
  window.addEventListener('popstate', function () {
    var now = location.pathname + location.search;
    if (now !== seen && $('[data-filters-form]')) location.reload();
    seen = now;
  });

  /* the drawer's first close target is the dim backdrop, which cannot take focus; so put focus on the real close button when the bag opens */
  var drawerEl = $('#cart-drawer');
  if (drawerEl && 'MutationObserver' in window) {
    new MutationObserver(function () {
      if (drawerEl.hidden || !drawerEl.classList.contains('is-open')) return;
      var dlg = $('.as-drawer2', drawerEl), btn = $('button[data-cart-close]', drawerEl);
      if (dlg && btn && !dlg.contains(doc.activeElement)) btn.focus();
    }).observe(drawerEl, { attributes: true, attributeFilter: ['class'] });
  }

  /* ---------- start ---------- */
  if (touch && $('[data-quick-add]')) {
    getCart().then(applyCart).catch(function () {});
    window.addEventListener('pageshow', function (e) { if (e.persisted) getCart().then(applyCart).catch(function () {}); });
    if ('MutationObserver' in window) {
      var t2;
      new MutationObserver(function (list) {
        var fresh = list.some(function (m) { return Array.prototype.some.call(m.addedNodes, function (n) { return n.nodeType === 1 && (n.matches('.as-plate') || n.querySelector('.as-plate')); }); });
        if (fresh) { clearTimeout(t2); t2 = setTimeout(syncCards, 50); }
      }).observe(doc.body, { childList: true, subtree: true });
    }
  }
})();